import { Facebook, Instagram,  Youtube, Twitter } from 'lucide-react';
import './Footer.css';
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="footer-logo-text">TREDIXO</span>
            </div>
            <div className="social-icons">
              <a href="https://www.facebook.com/tredixoltd/" className="social-icon" target="_blank" rel="noopener noreferrer">
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/tredixo_official/" className="social-icon" target="_blank" rel="noopener noreferrer">
                <Instagram size={20} />
              </a>
              {/* <button className="social-icon" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <MessageCircle size={20} />
              </button> */}
              <a href="https://www.youtube.com/@Tredixo_officialYT" className="social-icon" target="_blank" rel="noopener noreferrer">
                <Youtube size={20} />
              </a>
              <a href="https://x.com/tredixo" className="social-icon" target="_blank" rel="noopener noreferrer">
                <Twitter size={20} />
              </a>
             <a
  href="https://t.me/tredixo_official"
  className="social-icon"
  target="_blank"
  rel="noopener noreferrer"
>
  <svg
    viewBox="0 0 24 24"
    width="20"
    height="20"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z" />
  </svg>
</a>

          
            </div>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading"><a href="/about" style={{color:"#fff"}}>About Us</a></h4>
            <ul className="footer-links">
              <li>
      <Link to="/why-tredixo">Why Tredixo</Link>
    </li>
    <li>
      <Link to="/terms-conditions">Terms & Conditions</Link>
    </li>
    <li>
      <Link to="/privacy-policy">Privacy Policy</Link>
    </li>
    <li>
      <Link to="/affiliate">Become An Affiliate</Link>
    </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Knowledge Center</h4>
            <ul className="footer-links">
              <li><Link to="/trading">Trading</Link></li>
              <li><Link to="/equity-trading">Equity Trading</Link></li>
              <li><Link to="/futures-options">Futures & Options</Link></li>
              <li><Link to="/commodity-trading">Commodity Trading</Link></li>
              <li><Link to="/margin-trading">Margin Trading</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Products</h4>
            <ul className="footer-links">
              <li><Link to="/cfd-instrument">CFD Instrument</Link></li>
              <li><Link to="/stocks">Stocks</Link></li>
              <li><Link to="/commodity">Commodity</Link></li>
              <li><Link to="/indexes">Indexes</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-heading">Platforms</h4>
            <ul className="footer-links">
              <li><Link to="/web-trader">Web Trader</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
